import {
  AccordionDetails as Box,
  TextField,
  Autocomplete,
  Button,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Magasin } from "../../../models/Magasin";
import {
  useAddSecMagasinMutation,
  useGetMagasinsQuery,
} from "../../../redux/features/cache";
import { useState } from "react";
import { useAppDispatch } from "../../../redux/store";
import { addRequestToSend } from "../../../redux/features/appStateSlice";
import { RequestToSend } from "../../../models/RequestToSend";

export interface ISelectionFormProps {
  plans_seq: number | undefined;
  setOpen: any;
  canDelete: boolean;
}

export default function MagasinForm({
  plans_seq,
  setOpen,
  canDelete,
}: ISelectionFormProps) {
  const { data: magasins = [] as Magasin[] } = useGetMagasinsQuery({
    banniere: "",
    treeView: false,
  });
  const [mag, setMag] = useState<number>(-1);
  const [vise, setVise] = useState<number>(0);
  const [addSecMagasin] = useAddSecMagasinMutation();
  const dispatch = useAppDispatch();
  const submit = () => {
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Ajout section magasin ${mag}`,
          addSecMagasin,
          () => {
            setOpen(false);
          },
          {},
          {
            plans_seq: plans_seq,
            mag_num: mag,
            nombre_vise: vise,
          },
          []
        )
      )
    );
  };

  return (
    <Box sx={{ display: "flex", p: 0 }}>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          p: 0,
        }}
      >
        <Autocomplete
          options={magasins}
          clearOnBlur={false}
          getOptionLabel={(cat) => `${cat.mag_nom}`}
          onChange={(e, data) => setMag(data!.mag_num)}
          onInputChange={(event) => {
            event?.stopPropagation();
          }}
          sx={{ width: "33%", m: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{
                color: "red",
              }}
              {...params}
              label="Magasin"
            />
          )}
        />
        <TextField
          label="Objectif produit sur plancher"
          sx={{ width: "33%", m: 1 }}
          type="number"
          onChange={(e) => setVise(parseInt(e.target.value))}
        />

        <TextField
          label="Qté actuel sur plancher"
          sx={{ width: "33%", m: 1 }}
          disabled
        />
      </Box>

      <span
        style={{
          display: "flex",
          alignItems: "center",
          padding: "6px 28px",
          cursor: "pointer",
        }}
        className={`save-wrapper`}
      >
        <span
          className={`k-icon k-font-icon k-i-save k-icon-xl`}
          onClick={submit}
        ></span>
      </span>
      <Tooltip title="Annuler">
        <span style={{ display: "flex" }}>
          <Button
            disabled={!canDelete}
            onClick={() => setOpen(false)}
            color="error"
          >
            <DeleteIcon />{" "}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
